import { filtersHelper } from '@/utils';
import { candidateModel } from '@/models/api/candidate.model';

export const candidateMedicalModel = (data) => ({
    uuid: data.uuid,
    physicalImpairmentDisease: data.physical_impairment_disease,
    physicalImpairmentDiseaseRemark: data.physical_impairment_disease_remark,
    seriousIllness: data.serious_illness,
    seriousIllnessRemark: data.serious_illness_remark,
    medicationAllergy: data.medication_allergy,
    medicationAllergyRemark: data.medication_allergy_remark,
    bloodType: data.blood_type,
    isPregnant: data.is_pregnant,
    pregnantMonth: data.pregnant_month,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    candidate: data.candidate ? candidateModel(data.candidate) : null,
});